<template>
  <div class="container">
    <ul class="list-group">
      <li class="list-group-item text-start" v-for="l in sorted_list" :key="l">
        <div class="row">
          <div class="col">
            <input
              type="text"
              class="form-control"
              v-model.number="new_sort_value"
              v-if="pool_list_id == l.id"
              @keyup.enter="updateSort()"
            />
            <span v-else> {{ l.sort }}. </span>
          </div>
          <div class="col-10">
            <span @click="editThis(l.id, l.sort)">{{
              fetchPlayerName(l.player_id)
            }}</span>
          </div>
          <div class="col" v-if="pool_list_id == l.id">
            <i
              class="bi bi-trash text-danger"
              @click="deleteSingleItem(l.id)"
            ></i>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <i class="bi bi-trash text-danger" @click="deleteList()"></i>
      </li>
    </ul>
  </div>
</template>
<script setup>
import {
  defineProps,
  ref,
  onMounted,
  computed,
  onBeforeMount,
  defineEmits,
} from "vue";
import supabase from "@/supabase/config";
import { useStore } from "@/store/index";
const store = useStore();
const props = defineProps(["list", "pool_id"]);
const emit = defineEmits(["listDeleted", "sortUpdate"]);
const list = ref([]);
const pool_list_id = ref("");
const new_sort_value = ref(0);
const editThis = (id, old_sort_value) => {
  if (pool_list_id.value != id) {
    pool_list_id.value = id;
    new_sort_value.value = old_sort_value;
  } else {
    pool_list_id.value = "";
    new_sort_value.value = 0;
  }
};
const all_players = ref([]);
onBeforeMount(() => {
  fetchAllPlayers();
});
onMounted(() => {
  list.value = props.list;
});
const sorted_list = computed(() => {
  var arr = [];
  list.value.forEach((l) => {
    arr.push(l);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => a.sort - b.sort);
  return sorted_arr;
});

const fetchAllPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_players.value = players;
};
const fetchPlayerName = (id) => {
  var name = "";
  all_players.value.forEach((ap) => {
    if (ap.id == id) {
      name = ap.name;
    }
  });
  return name;
};
const deleteList = async () => {
  const { error } = await supabase
    .from("pool_list")
    .delete()
    .eq("pool_id", props.pool_id);
  if (!error) {
    emit("listDeleted");
  }
};
const updateSort = async () => {
  const { data, error } = await supabase
    .from("pool_list")
    .update({ sort: new_sort_value.value })
    .eq("id", pool_list_id.value)
    .select();
  if (!error) {
    pool_list_id.value = "";
    new_sort_value.value = null;
    emit("sortUpdate");
  }
};
const deleteSingleItem = async (id) => {
  const { error } = await supabase.from("pool_list").delete().eq("id", id);
  if (!error) {
    emit("sortUpdate");
  }
};
</script>

<style scoped>
.tinytxt {
  font-size: 10px;
}
.list-group-item {
  padding: 2px;
}
</style>
